import React from 'react';
import { Link } from 'react-router-dom';
import './style.css';
import { Row, Col, Button } from 'react-bootstrap';
import ExternalImage from '../product/ExternalImage';
import MoneyUtils from '../../services/MoneyUtils';

function ProductItem(props) {
  const linkActionForKlaviyoView = () =>
    props.recordKlavioView(props.product, props.page);

  const disableClick = (e) => e.preventDefault();

  let actualCost;
  let originalCost;
  if (props.product.subscriptionPlan) {
    actualCost = props.product.subscriptionPlan.costWithCoupon;
    ({ originalCost } = props.product.subscriptionPlan);
  } else {
    ({ actualCost } = props.product);
    ({ originalCost } = props.product);
  }

  if (
    props.postPurchasePromo &&
    props.product.ownPromoData &&
    (props.product.ownPromoData.isPostPurchasePromo ||
      props.product.ownPromoData.isVitaminPromo ||
      props.product.ownPromoData.isPreCheckoutPromo ||
      props.product.ownPromoData.isSubPromo)
  ) {
    actualCost = props.product.ownPromoData.cost;
    ({ originalCost } = props.product);
  }

  if (props.amountToCharge) {
    actualCost = props.amountToCharge;
  }

  const determineColumnWidth = (size) => {
    if (size === 'xs' || size === 'sm') {
      if (props.threeColumns) return { span: 10, offset: 1 };
      if (props.isPostPurchasePromoVitamin || props.fullWidth) return 12;
      if (props.horizontalLayout) return 6;
      return 6;
    }

    if (size === 'md') {
      if (props.threeColumns) return { span: 3, offset: 0 };
      if (props.isPostPurchasePromoVitamin) return 12;
      if (props.horizontalLayout) return 6;
      if (props.postPurchasePromo) return 4;
      return 3;
    }

    if (size === 'lg') {
      if (props.threeColumns) return { span: 3, offset: 0 };
      if (props.isPostPurchasePromoVitamin) return 12;
      if (props.horizontalLayout) return 6;
      if (props.postPurchasePromo) return 4;
      return 3;
    }

    return 4;
  };

  return (
    <Col
      key={`${props.product._id}-${props.index}`}
      xs={determineColumnWidth('xs')}
      sm={determineColumnWidth('sm')}
      md={determineColumnWidth('md')}
      lg={determineColumnWidth('lg')}
      className={`productItem ${props.horizontalLayout ? 'horizontal' : ''}`}
      id={props.id || 'productItemCol'}
    >
      <Row className='productItemRow'>
        <Col
          xs={12}
          sm={12}
          md={props.horizontalLayout ? 6 : 12}
          lg={props.horizontalLayout ? 6 : 12}
          className={
            !props.weekByWeek ? 'productImage' : 'weekByWeekProductImage'
          }
        >
          <Link
            to={`/products/${props.product.urlName}`}
            className={
              !props.disableProductClick ? 'productLink' : 'disabled-link'
            }
            onClick={
              !props.disableProductClick
                ? linkActionForKlaviyoView
                : disableClick
            }
          >
            <ExternalImage
              src={props.productMedia}
              sizes='(max-width: 414px) 50vw, 25vw'
              alt={props.product.name}
              title={`${props.product.name} Photo`}
            />
          </Link>
        </Col>
        {props.weekByWeek ? <hr className='gray-line' /> : null}
        <Col
          className={
            props.horizontalLayout
              ? 'shopProductInfo horizontal'
              : 'shopProductInfo'
          }
          xs={12}
          sm={12}
          md={props.horizontalLayout ? { span: 5, offset: 1 } : 12}
          lg={props.horizontalLayout ? { span: 5, offset: 1 } : 12}
        >
          <Link
            to={`/products/${props.product.urlName}`}
            className={
              !props.disableProductClick ? 'productLink' : 'disabled-link'
            }
            onClick={
              !props.disableProductClick
                ? linkActionForKlaviyoView
                : disableClick
            }
          >
            <div className='productTitle'>{props.productName}</div>
            <div className='productBrand'>{props.product.brand}</div>
            {props.isPostPurchasePromoVitamin ? (
              <div className='productDescription'>
                {props.productDescription}
              </div>
            ) : null}
            <div
              id='starRating'
              className='yotpo bottomLine'
              data-yotpo-product-id={props.product.sku}
            />
            {props.vipDiscount ? (
              <div className='vip-discount'>
                VIP Discount ({props.vipDiscount}% Off)
              </div>
            ) : null}
            {!props.hidePrice ? (
              <Row noGutters className='priceWrapper'>
                {props.product.discounted === true ? (
                  <div className='slashedPrice'>
                    <div className='center-align'>
                      <div>${MoneyUtils.formatAsMoney(originalCost)}</div>
                    </div>
                  </div>
                ) : null}
                <div className='productPrice'>
                  ${MoneyUtils.formatAsMoney(actualCost)}
                  {props.isPostPurchasePromoVitamin || props.showPerMonthPrice
                    ? '/month'
                    : null}
                </div>
              </Row>
            ) : null}
          </Link>
          {props.detailsAction ? (
            <div
              onClick={props.detailsAction}
              role='button'
              tabIndex={props.index}
              onKeyUp={props.detailsAction}
              className='details'
            >
              Details
            </div>
          ) : null}
          {!props.hideButton ? (
            <div className='productAddToCart'>
              <Button
                disabled={props.isButtonDisabled}
                onClick={props.buttonAction}
                variant={props.buttonVariant ? props.buttonVariant : 'primary'}
                className={
                  props.weekByWeek ? 'weekByWeekAddToCart' : 'addToCartShop'
                }
                aria-label={`Add ${props.productName} to cart`}
              >
                {props.buttonText}
              </Button>
            </div>
          ) : null}
          {props.productQuantity < 50 && props.productQuantity > 0 ? (
            <Row>
              <Col className='productQuantityLeft'>
                Only {props.productQuantity} left - Order soon!
              </Col>
            </Row>
          ) : null}
        </Col>
      </Row>
    </Col>
  );
}

export default React.memo(ProductItem);
